export default "__VITE_ASSET__BxIBbchD__"